
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scheduleDiscounts",
      function () {
        return require("private-next-pages/scheduleDiscounts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scheduleDiscounts"])
      });
    }
  